import React from 'react';

import { useTranslation } from 'next-i18next';

import { getAsset } from '../../../helpers';
import { ISelectedBlogExtraProps } from '../Blog.types';
import BlogCard from '../BlogCard';
import BlogListWrapper from '../BlogListWrapper';
import RelatedBlogsStyles from './RelatedBlogs.module.scss';

const RelatedBlogs = ({ relatedPosts }: ISelectedBlogExtraProps) => {
  const { t } = useTranslation('resources');
  const {
    relatedPosts: { textHeader },
    articles,
    blogPath,
  } = t('blog', {
    returnObjects: true,
  }) as any;

  if (relatedPosts.length === 0) return;

  return (
    <div className={RelatedBlogsStyles.relatedBlogs}>
      <h2>{textHeader.title}</h2>
      <BlogListWrapper variant="relatedBlog">
        {relatedPosts.map((relatedPost, index) => {
          const t = relatedPost.translations[0];
          if (!t) return '';

          return (
            <BlogCard
              variant="relatedBlog"
              key={index}
              data={{
                category: t.category,
                title: t.title_short || t.title,
                description: t.summary,
                tags: relatedPost.tags.map((tag) => tag.tags_id?.name),
                img: getAsset(relatedPost.thumbnail, true),
                body: t.body,
                button: {
                  path: `${blogPath}/${t.slug}/`,
                  label: articles.link,
                  title: t.title,
                },
              }}
            />
          );
        })}
      </BlogListWrapper>
    </div>
  );
};

export default RelatedBlogs;
